import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BusinessServicesComponent} from './business-services.component';
import {OwnerProfileComponent} from './owner-profile/owner-profile.component';
import {OwnerConfirmComponent} from './owner-confirm/owner-confirm.component';
import {BusinessSearchResultComponent} from './business-search-result/business-search-result.component';
import {BusinessCreditReportComponent} from './business-credit-report/business-credit-report.component';
import {LumbermensTradeAccountDetComponent} from './business-credit-report/lumbermens-trade-account-det/lumbermens-trade-account-det.component';
// eslint-disable-next-line max-len
import {
  LumbermensAutomatedTradeSubmissionDetComponent
} from './business-credit-report/lumbermens-automated-trade-submission-det/lumbermens-automated-trade-submission-det.component';
import {CommonTudComponentsModule} from '../common/common-tud-components.module';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatTabsModule} from '@angular/material/tabs';
import {MatStepperModule} from '@angular/material/stepper';
import {BusinessServicesRoutingModule} from './business-services-routing.module';
import {NgxMaskModule} from 'ngx-mask';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {GoogleMapsModule} from '@angular/google-maps';
import {provideHttpClient, withJsonpSupport} from '@angular/common/http';

@NgModule({
    exports: [
        NgbModule
    ], imports: [
        //TUD Modules
        CommonTudComponentsModule,
        BusinessServicesRoutingModule,
        //Dependencies
        CommonModule,
        NgbModule,
        TranslateModule.forChild(),
        NgxMaskModule.forChild(),
        ReactiveFormsModule,
        MatStepperModule,
        MatTabsModule,
        FontAwesomeModule,
        GoogleMapsModule,
        BusinessServicesComponent,
        OwnerProfileComponent,
        OwnerConfirmComponent,
        BusinessSearchResultComponent,
        BusinessCreditReportComponent,
        LumbermensTradeAccountDetComponent,
        LumbermensAutomatedTradeSubmissionDetComponent
    ], providers: [provideHttpClient(withJsonpSupport())]})
export class BusinessServicesModule {}
